import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";
import { couponCodeAtom } from "src/atoms";
import { useApiError } from "src/hooks/useApiError";
import { getInicisData } from "src/service/pay";
import { IGetInicisDataRes } from "src/service/types/pay.type";

interface IPriceCheckerProps {
  priceType: string; // 요금제
  userPerPrice: number; // 사용자당 월 요금
  userPerPriceYear: number; // 사용자당 연 요금
  setInicisData: React.Dispatch<
    React.SetStateAction<IGetInicisDataRes | undefined>
  >; // INICIS 결제 데이터
  // payApply: ({
  //   orderID,
  //   subscriptionID,
  // }: {
  //   orderID: string;
  //   subscriptionID: string;
  // }) => void;
}

// InicisData 세팅
const InicisDataChecker = ({
  priceType,
  userPerPrice,
  userPerPriceYear,
  setInicisData,
}: IPriceCheckerProps) => {
  const { values } = useFormikContext<any>();
  const { payTerm, licenseCount } = values;
  const [couponCodeInfo, setCouponCodeInfo] = useRecoilState(couponCodeAtom);
  const { handleError } = useApiError();
  const { data } = useQuery(
    [
      "getInicisData",
      payTerm,
      licenseCount,
      userPerPrice,
      userPerPriceYear,
      priceType,
      couponCodeInfo,
    ],
    async () => {
      if (couponCodeInfo) {
        return await getInicisData({
          price:
            payTerm === "year"
              ? userPerPriceYear * 12 * licenseCount
              : userPerPrice * licenseCount,
          couponCode: couponCodeInfo.couponCode,
        });
      } else {
        return await getInicisData({
          price:
            payTerm === "year"
              ? userPerPriceYear * 12 * licenseCount
              : userPerPrice * licenseCount,
        });
      }
    },
    {
      enabled: !!(
        payTerm &&
        licenseCount &&
        userPerPrice &&
        userPerPriceYear &&
        priceType
      ),
      // refetchOnMount: true,
      onSuccess: (inicisData) => {
        setInicisData(inicisData);
      },
      onError: handleError,
    }
  );
  // async function init() {
  //   if(couponCodeInfo) {

  //   }else {

  //     await getInicisData({
  //       price:
  //         payTerm === "year"
  //           ? userPerPriceYear * 12 * licenseCount
  //           : userPerPrice * licenseCount,
  //     })
  //       .then((inicisData) => {
  //         setInicisData(inicisData);
  //         // 아래 3줄 확인할것
  //         // 주문정보 서버에 저장 -> 이후 해당 내용을 기반으로 결제 진행

  //         // payApply({
  //         //   orderID: inicisData?.oid,
  //         //   subscriptionID: "Inicis",
  //         // });
  //         return;
  //       })
  //       .catch((e) => {
  //         console.log("getInicisData err", e);
  //         return;
  //       });
  //   }
  // }
  // useEffect(() => {
  //   if (
  //     payTerm &&
  //     licenseCount &&
  //     userPerPrice &&
  //     userPerPriceYear &&
  //     priceType
  //   ) {
  //     init();
  //   }
  // }, [licenseCount, payTerm, userPerPrice, userPerPriceYear, priceType, couponCodeInfo]);
  return null;
};

export default InicisDataChecker;
